module.exports = __webpack_public_path__ + "static/img/viral_14.858e8bdf.jpg";